import { useAuth } from '../../App';
import { useTaskReminders } from '../../hooks/useTaskReminders';

/**
 * Background component that manages task reminder notifications
 * Automatically polls for upcoming reminders when user has notification method selected
 */
const ReminderManager = () => {
  const { user } = useAuth();
  useTaskReminders(user);
  return null; // This component doesn't render anything
};

export default ReminderManager;
